import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { ConfigManagerService } from '@xpo-ltl/config-manager';

import { detect } from 'detect-browser';

import { ConfigManagerProperties } from '@shared/enums';
import { ClientEmailService } from '@shared/services/client-email/client-email.service';
import { EmailEnum } from '@core/enums/email.enum';
import { FeedbackSubjectEnum } from '@core/enums/feedback.enum';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppFooterComponent implements OnInit {

  browserInfo;
  copyrightYear: number;

  constructor(
    private configManagerService: ConfigManagerService,
    private clientEmailService: ClientEmailService,
  ) {
    this.copyrightYear = new Date().getFullYear();
  }

  get buildVersion(): string {
    return this.configManagerService.getSetting<string>(ConfigManagerProperties.buildVersion);
  }

  ngOnInit(): void {
    this.browserInfo = detect();
  }

  getMailLink(): string {
    const to = EmailEnum.invoicingSupport;
    const subject = FeedbackSubjectEnum.subject;
    return this.clientEmailService.getSimpleEmailLink(to, subject);
  }
}
